function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScrollButton = function SvgScrollButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.69 95.69",
    width: "95px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 47.85,
    cy: 47.85,
    r: 47.85,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.85,
    cy: 47.85,
    r: 38.27,
    style: {
      fill: "#c1272d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.91,40,48.85,25.78l0,0-.19-.13a1,1,0,0,0-.17-.1l0,0-.16,0-.2-.05h-.42l-.2.05-.17,0,0,0a1.51,1.51,0,0,0-.17.1,1.18,1.18,0,0,0-.18.13s0,0,0,0L31.79,40a1.46,1.46,0,0,0,2,2.13l12.6-11.9V68.84a1.46,1.46,0,0,0,2.92,0V30.23L61.9,42.13a1.46,1.46,0,0,0,2-2.13Z",
    style: {
      fill: "#efefef"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ScrollButton.6a41d52a.svg";
export { ForwardRef as ReactComponent };